import SettingField from 'components/Fields/ReduxForm/SettingField'
import styles from './RoleForm.css'
import {connect} from 'react-redux'
import {browserHistory} from 'react-router'
import {Field, reduxForm, formValueSelector, change, FieldArray, isDirty} from 'redux-form'
import AccessApp from './AccessApp'
import AccessAppPermission from './AccessAppPermission'
import AccessBackOfficePermission from './AccessBackOfficePermission'
import AccessBackOffice from './AccessBackOffice'
import ToggleDisplay from 'react-toggle-display'
import RoleDelete from './RoleDelete'
import RoleCancelSubmit from './RoleCancelSubmit'
import * as roleSelector from 'selectors/employees/role'
import {askConfirmAction} from 'actions/confirm-action'
import ConfirmActionModal from 'components/ConfirmActionModal'
import {push} from 'react-router-redux'
import * as mpRole from 'mixpanel/employees/role'
import _ from 'lodash'
import {
  submitFormUpdate,
  submitFormCreate,
  deleteRole,
  setRoleDetail
} from 'actions/employees/role'

class RoleForm extends React.Component {

  componentDidMount () {
    const {expired} = this.props.subscriptionExpired
    if (!expired) {
      this.removeBrowserListener = browserHistory.listenBefore(location => {
        if (this.props.isDirtyRole && !this.props.nextAction) {
          this.props.askConfirmAction(push(location))
          return false
        }
      })
    } else {
      browserHistory.push('/settings/billing')
    }
  }

  componentWillUnmount () {
    if (this.removeBrowserListener) {
      this.removeBrowserListener()
    }
    this.props.setRoleDetail(null)
  }

  render () {
    let handleSubmit = () => {}
    let isAccessAppChecked = this._isAccessAppChecked()
    let isAccessBackOfficeChecked = this._isAccessBackOfficeChecked()
    const {roleDetail, permissionsOf, apiError} = this.props
    const isNewRole = roleDetail === null
    return (
      <form style={{overflow: 'hidden'}} onSubmit={handleSubmit} className='full-height'>
        <div className={`${styles.container} role-container`}>
          <div className={styles.form}>
            <div style={{paddingTop: '10px'}} className={styles.title}>ROLE INFORMATION</div>
            <div className='row'>
              <div className='col-lg-12'>
                <div className='form-group'>
                  <Field
                    component={SettingField}
                    className='form-control'
                    name='name'
                    maxLength='30'
                    placeholder='Role Name'
                    type='text'
                    dis={roleDetail !== null && roleDetail.level === 2}
                  />
                </div>
              </div>
              <div style={{paddingTop: '35px'}} className='col-lg-12'>
                <div className={`col-lg-12 ${styles['access-container']}`}>
                  <AccessApp
                    checked={isAccessAppChecked}
                    onChange={this._onChangeAccessApp}
                    hasSubMenuChecked={this._isAccessAppHasSubMenuChecked()}
                  />
                  <ToggleDisplay show={this._shouldShowAccessAppPermission()}>
                    <FieldArray
                      name='active_permissions_app'
                      isOwner={this.props.user.is_owner}
                      roleDetail={roleDetail}
                      component={AccessAppPermission}
                      permissions={permissionsOf.app}
                      apiError={apiError}
                    />
                  </ToggleDisplay>
                </div>
              </div>
              <div style={{paddingTop: '35px'}} className='col-lg-12'>
                <div className={`col-lg-12 ${styles['access-container']}`}>
                  <AccessBackOffice
                    onChange={this._onChangeAccessBackOffice}
                    checked={isAccessBackOfficeChecked}
                    hasSubMenuChecked={this._isAccessBackOfficeHasSubMenuChecked()}
                  />
                  <ToggleDisplay show={this._shouldShowBackOfficePermission()}>
                    <FieldArray
                      name='active_permissions_backoffice'
                      component={AccessBackOfficePermission}
                      permissions={permissionsOf.backOffice}
                      isOwner={this.props.user.is_owner}
                      roleDetail={roleDetail}
                      apiError={apiError}
                    />
                  </ToggleDisplay>
                </div>
              </div>
            </div>
            <div style={{paddingTop: '35px'}} className={styles.title}>LIST OF EMPLOYEES</div>
            <div>
              {
                this._doesRoleHasEmployee()
                  ? roleDetail.employees.map((employee) => {
                    return <div className={`${styles.ellipsis}`}> {`${employee.first_name} ${employee.last_name}`} </div>
                  })
                  : <div className={styles['no-employee']}>{"There's no staff for this role yet."}</div>
              }
            </div>

          </div>

        </div>
        <div className={styles.footer}>
          {!isNewRole && <RoleDelete roleDetail={roleDetail} onClickDelete={this._onClickDeleteRole} />}
          <RoleCancelSubmit
            closeRightColumn={this.props.closeRightColumn}
            isNewRole={isNewRole}
            roleDetail={roleDetail}
            activePermissionApp={this.props.activePermissionApp}
            activePermissionBackOffice={this.props.activePermissionBackOffice}
            onSubmit={this._onSubmit}
            handleSubmit={this.props.handleSubmit}
            disableSubmit={this.props.isSubmittingForm}
          />
        </div>
        <ConfirmActionModal />
      </form>
    )
  }

  _onSubmit = (values, isNewRole) => {
    let permissionsId = []
    if (values.active_permissions_app && values.active_permissions_app.length > 0) {
      permissionsId = permissionsId.concat(values.active_permissions_app.map(e => e.id))
    }

    if (values.active_permissions_backoffice && values.active_permissions_backoffice.length > 0) {
      permissionsId = permissionsId.concat(values.active_permissions_backoffice.map(e => e.id))
    }

    let data = {
      name: values.name,
      permissions: permissionsId
    }

    if (isNewRole) {
      this.props.submitFormCreate(data, this.props.roles)
      mpRole.createRole(values)
    } else {
      data.roleId = this.props.roleDetail.id
      this.props.submitFormUpdate(data, this.props.roles)
      mpRole.editRole(values)
    }
  }

  _onClickDeleteRole = (role) => {
    mpRole.deleteRole(role)
    this.props.deleteRole(role.id, this.props.roles)
  }

  _doesRoleHasEmployee = () => {
    const {roleDetail} = this.props
    return Boolean(roleDetail && roleDetail.employees && roleDetail.employees.length > 0)
  }

  _onChangeAccessApp = (e) => {
    let willBeActive = !this._isAccessAppHasSubMenuChecked()
    let {change} = this.props
    if (willBeActive) {
      change('active_permissions_app', this.props.permissionsOf.app)
    } else {
      change('active_permissions_app', [])
    }
  }

  _isAccessAppChecked = () => {
    const {activePermissionApp, permissionsOf} = this.props
    return Boolean(activePermissionApp && activePermissionApp.length === permissionsOf.app.length)
  }

  _isAccessAppHasSubMenuChecked = () => {
    const {activePermissionApp} = this.props
    return Boolean(activePermissionApp && activePermissionApp.length > 0)
  }

  _shouldShowAccessAppPermission = () => {
    const {activePermissionApp} = this.props
    return Boolean(activePermissionApp && activePermissionApp.length > 0)
  }

  _onChangeAccessBackOffice = (e) => {
    let willBeActive = !this._isAccessBackOfficeHasSubMenuChecked()
    let {change, roleDetail} = this.props
    if (willBeActive) {
      let isOwner = this.props.user.is_owner
      let isNewRole = roleDetail === null
      let enabledPermissions = this.props.permissionsOf.backOffice

      // if a permission is disabled in manager, we are not able to
      // assign that permission in all level 3 role
      if (isOwner && (isNewRole || roleDetail.level !== 2)) {
        enabledPermissions = _.filter(enabledPermissions,
          (permission) => {
            return permission.menu.toUpperCase() !== 'EMPLOYEES'
          })
      }

      change('active_permissions_backoffice', enabledPermissions)
    } else {
      change('active_permissions_backoffice', [])
    }
  }

  _isAccessBackOfficeChecked = () => {
    const {activePermissionBackOffice, permissionsOf, roleDetail} = this.props
    let assignablePermissions = permissionsOf.backOffice
    if (roleDetail === null || roleDetail.level !== 2) {
      assignablePermissions = _.filter(assignablePermissions, (e) => e.menu.toUpperCase() !== 'EMPLOYEES')
    }

    return Boolean(activePermissionBackOffice &&
      activePermissionBackOffice.length === assignablePermissions.length)
  }

  _isAccessBackOfficeHasSubMenuChecked = () => {
    const {activePermissionBackOffice} = this.props
    return Boolean(activePermissionBackOffice && activePermissionBackOffice.length > 0)
  }

  _shouldShowBackOfficePermission = () => {
    const {activePermissionBackOffice} = this.props
    return Boolean(activePermissionBackOffice && activePermissionBackOffice.length > 0)
  }
}

const ROLE = 'role'
const selector = formValueSelector(ROLE)

function mapStateToProps (state) {
  return {
    subscriptionExpired: state.subscriptionExpired,
    roleDetail: state.employee.role.roleDetail,
    roles: state.employee.role.roles,
    user: state.moka.user,
    apiError: state.employee.role.error,
    activePermissionApp: selector(state, 'active_permissions_app'),
    activePermissionBackOffice: selector(state, 'active_permissions_backoffice'),
    permissionsOf: roleSelector.getUserPermissionsOf(state),
    nextAction: state.confirmAction.nextAction,
    isDirtyRole: isDirty(ROLE)(state),
    isSubmittingForm: state.employee.role.isSubmittingForm
  }
}

const validate = (values, props) => {
  const errors = {}
  const {roles, roleDetail} = props
  if (!values.name) {
    errors.name = 'Role Name is Required'
  } else {
    const exist = _.find(roles, {name: values.name})
    if (exist) {
      // if its editting existing role, same name should not
      // prompt an error
      if (!roleDetail || roleDetail.name !== values.name) {
        errors.name = 'Role Name must be unique'
      }
    }
  }
  return errors
}

const mapForm = {
  form: ROLE,
  validate
}

export default connect(mapStateToProps, {
  change,
  submitFormUpdate,
  submitFormCreate,
  deleteRole,
  askConfirmAction,
  setRoleDetail
})(reduxForm(mapForm)(RoleForm))



// WEBPACK FOOTER //
// ./app/pages/Employees/Role/RoleDetail/RoleForm/RoleForm.js